import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const garmin = defineConnector({
  identifier: "garmin",
  name: "Garmin",
  tagLine: "GPS and fitness wearables",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://apis\\.garmin\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Find your Garmin API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Apply for API access at the [Garmin Developer Portal](https://developer.garmin.com/). Once approved, you'll receive a consumer key and access token for the Health API or Connect API.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Garmin account settings.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://apis.garmin.com/wellness-api/rest/user/id",
  },
});
